import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";
import { IShow } from "@eagerdog/interfaces";

export namespace UKCAgility {
  export const getForm = (show?: IShow): IEventRegisterRow[] => {
    // Helper function to check if a level is available in the show
    // For UKC Agility, all levels (both standard agility and games) are stored with show_element: "Agility"
    const isLevelAvailable = (level: string): boolean => {
      if (!show?.show_elements) return true; // If no show provided, show all options
      
      return show.show_elements.some(se => 
        se.show_element === Constants.dog_class_element.agility && se.level === level
      );
    };

    // Filter agility options based on available show elements
    const agilityOptions = [
      { value: Constants.dog_class_element_level.beginner_a, id: Constants.dog_class_element_level.beginner_a },
      { value: Constants.dog_class_element_level.beginner_b, id: Constants.dog_class_element_level.beginner_b },
      { value: Constants.dog_class_element_level.intermediate_a, id: Constants.dog_class_element_level.intermediate_a },
      { value: Constants.dog_class_element_level.intermediate_b, id: Constants.dog_class_element_level.intermediate_b },
      { value: Constants.dog_class_element_level.excellent, id: Constants.dog_class_element_level.excellent },
      { value: Constants.dog_class_element_level.grach, id: Constants.dog_class_element_level.grach },
      { value: Constants.dog_class_element_level.grach_a, id: Constants.dog_class_element_level.grach_a },
      { value: Constants.dog_class_element_level.ach, id: Constants.dog_class_element_level.ach },
      // Legacy GRACH B: not selectable in Create/Edit Show any more, so it only
      // appears for shows created before the rename (filtered below).
      { value: Constants.dog_class_element_level.grach_b, id: Constants.dog_class_element_level.grach_b },
    ].filter(option => isLevelAvailable(option.value));

    // Filter games options based on available show elements  
    const gamesOptions = [
      { value: Constants.dog_class_element_level.novice_hurdles, id: Constants.dog_class_element_level.novice_hurdles },
      { value: Constants.dog_class_element_level.elite_hurdles, id: Constants.dog_class_element_level.elite_hurdles },
      { value: Constants.dog_class_element_level.novice_tunnels, id: Constants.dog_class_element_level.novice_tunnels },
      { value: Constants.dog_class_element_level.elite_tunnels, id: Constants.dog_class_element_level.elite_tunnels },
      { value: Constants.dog_class_element_level.three_of_a_kind, id: Constants.dog_class_element_level.three_of_a_kind },
    ].filter(option => isLevelAvailable(option.value));

    const formRows: IEventRegisterRow[] = [];

    // Only add agility section if there are available options
    if (agilityOptions.length > 0) {
      formRows.push({
        allowDuplicates: false,
        inputs: [{
          type: "checkbox",
          label: Constants.dog_class_element.agility,
          multiSelect: true,
          mutuallyExclusive: [
            [
              Constants.dog_class_element_level.grach,
              Constants.dog_class_element_level.grach_a,
              Constants.dog_class_element_level.grach_b,
              Constants.dog_class_element_level.ach,
            ]
          ],
          multiClassMessages: {
            [Constants.dog_class_element_level.ach]: "Beginner B, Intermediate B",
            [Constants.dog_class_element_level.grach]: "Beginner B, Intermediate B, Excellent",
            [Constants.dog_class_element_level.grach_a]: "Beginner A, Intermediate A, Excellent",
            [Constants.dog_class_element_level.grach_b]: "Beginner B, Intermediate B, Excellent",
          },
          options: agilityOptions
        }]
      });
    }

    // Only add games section if there are available options
    if (gamesOptions.length > 0) {
      formRows.push({
        allowDuplicates: false,
        inputs: [{
          type: "checkbox",
          label: Constants.dog_class_element.games,
          multiSelect: true,
          options: gamesOptions
        }]
      });
    }

    return formRows;
  };

  // Keep backward compatibility with the old .form property
  export const form: IEventRegisterRow[] = getForm();
}